import React, { useContext} from "react";
import { Page } from "components/common";
import EmployeeContext from "contexts/EmployeeContext";
import { Trans } from "react-i18next";
import PrintButton from "pages/Xero/Reports/PrintButton";
import ShiftTable from "pages/PayrollHrNew/ShiftsManagement/ShiftTable";
import EmployeePaySlips from "./Payslips/List";
import EmployeeHolidays from "./PHolidays/List";
import EmployeeLoans from "./PLoans/List";
import Contracts from "./PContracts/List";
import EndOfServiceCalculation from "./PEndOfService/List";
import IqamaRenewalRequests from "./IqamaRenewalRequests/List";
import { Card, CardBody } from "reactstrap";
import { EmployeeAttendance } from "./Pattendance/list";

export const Portal = ({ client, t, match, ...props }) => {
  const { employee } = useContext(EmployeeContext);
  const employeeList = [employee]
  if (!employee) return null;

  return (
    <Page title={employee.connected_organisation__name} translate={false}>
      <Card className="shadow-sm border">
        <CardBody>
          <div className="row mb-3">
            <div className="col-6">
              <h5 className="d-print-none">
                <Trans>My Schedule</Trans>
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <ShiftTable portalEmployee={employeeList} t={t} employee_id={employee.id} />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="shadow-sm border">
        <CardBody>
          <div className="row">
            <div className="col-12">
              <Contracts t={t} employee={employee} client={client} match={match} limit={5} />
            </div>
          </div>
        </CardBody>
      </Card>
      {!employee.is_ended && (
        <React.Fragment>
          <EmployeeHolidays employee={employee} client={client} match={match} limit={5} />
          <hr className="d-print-none" />
          <EmployeeLoans employee={employee} client={client} match={match} limit={5} />
        </React.Fragment>
      )}
      <hr className="d-print-none" />

      <EmployeePaySlips employee={employee} client={client} limit={5} />
      {employee.is_ended && (
        <EndOfServiceCalculation employee={employee} client={client} limit={5} />
      )}
      {/* <PrintButton className="float-right" /> */}

      <EmployeeAttendance employee={employee} client={client} match={match} limit={5} t={t}/>
      <IqamaRenewalRequests client={client} match={match} limit={5} />
    </Page>
  );
};

export default Portal;
